import { useMemo, useState } from "react";
import Select from "../../../../../components/Select/Select";

const preventNegativeValues = (e: any) =>
  ["+", "-"].includes(e.key) && e.preventDefault();
const preventPasteNegative = (e: any) => {
  const clipboardData = e.clipboardData || window.Clipboard;
  const pastedData = parseFloat(clipboardData.getData("text"));
  if (pastedData < 0) {
    e.preventDefault();
  }
};
const isValidNumber = (input: string) => {
  const isEmptyOrWhitespace = /^\s*$/;
  return !isEmptyOrWhitespace.test(input) && !isNaN(Number(input));
};

export const RangeCard = ({
  onDelete,
  cardIndex,
  cards,
  disabled = false,
  breakPoint,
  fees,
  setFees,
  setBreakPoint,
  type,
  setType,
}: any) => {
  const error =
    (cardIndex === 0 &&
      cards.length > 1 &&
      (breakPoint[cardIndex] <= 0 || !isValidNumber(breakPoint[cardIndex]))) ||
    (cardIndex > 0 &&
      cardIndex < cards.length &&
      Number(breakPoint[cardIndex - 1]) >= Number(breakPoint[cardIndex]));
  const error1 =
    cardIndex < cards.length - 1 && isNaN(Number(breakPoint[cardIndex]));

  return (
    <div>
      <div className="flex justify-between items-center">
        <h3 className=" text-sm font-medium text-edvion_black">
          Charge {cardIndex + 1}
        </h3>
        <h3 className=" text-sm font-medium text-edvion_black">Amount</h3>
      </div>
      <div className="flex justify-between gap-4 items-center mt-4">
        <div className="flex items-end gap-4 min-w-[16rem] max-w-[20rem]">
          <input
            type="number"
            name="initialRange"
            disabled={true}
            value={cardIndex === 0 ? 0 : breakPoint[cardIndex - 1]}
            placeholder="set initial range"
            className="rounded-lg border text-[#000000CC] text-xs border-[#959595] px-4 py-1.5 w-full focus:outline-none placeholder:text-[#00000066] placeholder:text-xs "
          />

          <input
            type="text"
            name="finalRange"
            pattern="/^[0-9∞]*$/"
            onChange={(e) => {
              if (/^[0-9∞]*$/.test(e.target.value)) {
                setBreakPoint(
                  breakPoint.map((v: any, i: number) => {
                    if (i === cardIndex) {
                      return e.target.value;
                    } else {
                      return breakPoint[i];
                    }
                  })
                );
              }
            }}
            disabled={disabled || cardIndex === cards.length - 1}
            placeholder="set final range"
            value={cardIndex === cards.length - 1 ? "∞" : breakPoint[cardIndex]}
            className={
              "rounded-lg border text-[#000000CC] text-xs border-[#959595] px-4 py-1.5 w-full focus:outline-none placeholder:text-[#00000066] placeholder:text-xs " +
              ((error || error1) && " border border-red-500")
            }
          />
        </div>
        <div className="items-center flex gap-x-2">
          <div className="w-20">
            <input
              type="number"
              name="amount"
              value={fees[cardIndex]}
              onChange={(e) => {
                setFees(
                  fees.map((v: any, i: number) => {
                    if (i === cardIndex) {
                      return e.target.value;
                    } else {
                      return fees[i];
                    }
                  })
                );
              }}
              disabled={disabled}
              className={
                "rounded-lg border text-[#000000CC] text-xs border-[#959595] px-4 py-1.5 w-full focus:outline-none placeholder:text-[#00000066] placeholder:text-xs placeholder:text-right "
              }
              min={0}
              onKeyDown={preventNegativeValues}
              onPaste={preventPasteNegative}
            />
          </div>

          <Select
            className="max-w-fit -mt-2"
            selected={{ name: type[cardIndex] || "PERCENT" }}
            setSelected={(e: any) => {
              setType(
                type.map((v: any, i: number) => {
                  if (i === cardIndex) {
                    return e.name;
                  } else {
                    return type[i];
                  }
                })
              );
            }}
            options={["PERCENT", "FLAT"].map((value) => {
              return { name: value };
            })}
          />
        </div>
      </div>
      <div className="flex justify-end mt-2">
        {!disabled && cards.length > 1 && cards.length === cardIndex + 1 && (
          <button
            className="text-[#6F6AF8] text-xs font-medium"
            onClick={onDelete}
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
};

function KmRateCard({
  card_data = [1],
  breakPoint_data = [],
  fees_data = [0],
  amountType_data = ["PERCENT"],
  updateMDR,
  isTrusteeList = false,
  isEmptyBulkArr = false,
}: any) {
  const [cards, setCards] = useState<any>(card_data);
  const [breakPoint, setBreakPoint] = useState<any>(breakPoint_data);
  const [fees, setFees] = useState<any>(fees_data.length ? fees_data : [0]);
  const [type, setType] = useState<any>(
    amountType_data.length ? amountType_data : ["PERCENT"]
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isValidInput = useMemo(() => {
    return !breakPoint
      .map((c: any, i: number) => {
        if (i === 0) {
          return isValidNumber(breakPoint[i]) && breakPoint[i] > 0;
        } else {
          return (
            isValidNumber(breakPoint[i - 1]) &&
            isValidNumber(breakPoint[i]) &&
            Number(breakPoint[i - 1]) < Number(breakPoint[i])
          );
        }
      })
      .includes(false);
  }, [breakPoint]);

  const addCard = () => {
    setCards([...cards, cards.length]);
    if (cards.length > 0) {
      setBreakPoint([...breakPoint, ""]);
    }
    if (cards.length > 0) setFees([...fees, 0]);
    if (cards.length > 0) setType([...type, ""]);
  };
  const deleteCard = (index: any) => {
    setCards(cards.filter((cardIndex: any, i: any) => i !== index));
    setBreakPoint(breakPoint.slice(0, breakPoint.length - 1));
    setFees(fees.slice(0, fees.length - 1));
    setType(type.slice(0, type.length - 1));
  };

  return (
    <div className="h-[300px] shadow rounded-md p-4 flex flex-col justify-between">
      <div>
        <div className="flex justify-between items-center mb-8">
          <button
            className="capitalize text-[#6F6AF8] text-xs font-medium"
            onClick={addCard}
          >
            + add new range
          </button>
        </div>
        <div className="space-y-4 overflow-hidden overflow-y-auto h-[180px] pr-6">
          {cards.map((cardIndex: any, index: any) => (
            <RangeCard
              breakPoint={breakPoint}
              setBreakPoint={setBreakPoint}
              type={type}
              setType={setType}
              key={index}
              cards={cards}
              fees={fees}
              setFees={setFees}
              cardIndex={index}
              onDelete={() => deleteCard(index)}
            />
          ))}
        </div>
      </div>
      <div className="flex justify-end">
        <button
          disabled={
            isSubmitting ||
            (isTrusteeList
              ? isEmptyBulkArr || !isValidInput || updateMDR === undefined
              : !isValidInput || updateMDR === undefined)
          }
          onClick={async () => {
            setIsSubmitting(true);

            try {
              breakPoint.push(null);

              let range_charge: any = [];
              fees.forEach((fee: any, index: number) => {
                let upto = breakPoint[index]
                  ? parseInt(breakPoint[index], 10)
                  : null;

                range_charge.push({
                  upto: upto,
                  charge: Number(fee),
                  charge_type: type[index] || "PERCENT",
                });
              });

              await updateMDR(range_charge);
            } catch (e) {
              console.error(e);
            } finally {
              setIsSubmitting(false);
            }
          }}
          className="rounded-lg disabled:bg-[#D9D9D978] disabled:text-[#959595] bg-blue-700 text-white px-8 py-1 max-w-fit"
        >
          {isSubmitting ? "Submitting..." : "Set Charges"}
        </button>
      </div>
    </div>
  );
}

export default KmRateCard;
